<template>
  <div id="app" class="app">
    <template v-if="$route.query.isProvince ">
      <TopDynamic v-if="menuData && show && $route.path!='/searchDynamic' "></TopDynamic>
    </template>
    <template v-else>
      <Top v-if="menuData && show" />
    </template>
    <router-view v-if="menuData" />
    <Footer v-show="show && $route.path!='/searchDynamic' "  />
  </div>
</template>

<script>
import Top from "@/components/Top";
import TopDynamic from "@/components/TopDynamic.vue";
import Footer from "@/components/Footer";
export default {
  name: "App",
  components: {
    Top,
    Footer,
    TopDynamic
  },
  data() {
    return {
      menuData: null,
      show: true
    };
  },
  created() {
    this.loadMenu();
  },
  methods: {
    async loadMenu() {
      const {
        data: { code, data }
      } = await this.$axios({
        method: "get",
        url: "/getIndexMenu"
      });
      if (code === 0) {
        this.menuData = data;
        this.$store.commit("updateMenus", data);
      }
    }
  },
  watch: {
    $route: {
      handler(val) {
        val.name === "search" ? (this.show = false) : (this.show = true);
      }
    }
  }
};
</script>

<style>
#app {
  background: url(./assets/imgs/bg.png);
  margin: 0 auto;
  font-family: Microsoft YaHei;
  color: #474747;
}

.app {
  max-width: 10rem;
}
</style>
